import { Trash04Icon } from '@langchain/untitled-ui-icons';

import { useParams } from 'react-router-dom';

import { DeleteConfirmationButton } from '@/components/Delete';
import { IconButton, Tooltip } from '@/design-system';
import { useDeleteFilterViewMutation } from '@/hooks/useSwr';
import { FilterViewSchema } from '@/types/schema';

export function DeleteSavedFilterButton(props: {
  filterView: FilterViewSchema;
  onToggleSwitch?: () => void;
  setFilterBarOpen: (open: boolean) => void;
}) {
  const { sessionId } = useParams();
  const deleteFilter = useDeleteFilterViewMutation(
    sessionId,
    props.filterView?.id
  );

  const handleDelete = async () => {
    if (props.filterView?.id) {
      await deleteFilter.trigger({});
    }
    props.setFilterBarOpen(false);
    if (props.onToggleSwitch) {
      props.onToggleSwitch();
    }
  };

  return (
    <Tooltip title="Delete filter" side="top">
      <DeleteConfirmationButton
        title="Confirm Deletion"
        description="Are you sure you want to delete this filter?"
        deleteButtonText="Delete"
        onDelete={handleDelete}
        isDeleting={deleteFilter.isMutating}
        trigger={
          <IconButton
            icon={Trash04Icon}
            label="Delete filter"
            color="secondary"
            variant="plain"
          />
        }
      />
    </Tooltip>
  );
}

export function ClearFilterButton(props: {
  hasFilters: boolean;
  onDeleteFilterValues: () => void;
  disabled?: boolean;
}) {
  if (!props.hasFilters) {
    return null;
  }
  return (
    <IconButton
      color="secondary"
      variant="plain"
      icon={Trash04Icon}
      label="Clear filters"
      disabled={props.disabled}
      onClick={props.onDeleteFilterValues}
    />
  );
}
